import type { FC } from 'react';
import { getIcon } from '../components/icons';

interface PlaceholderProps {
  title: string;
  pageType?: string;
  icon?: string;
}

/**
 * Fallback screen for routes that don't (yet) have a real implementation.
 * The nav, breadcrumb and module switcher are fully wired from the config —
 * this stands in for the page body so every menu item is reachable.
 */
export const Placeholder: FC<PlaceholderProps> = ({ title, pageType, icon }) => {
  const Icon = getIcon(icon) ?? getIcon('clipboard');
  return (
    <div className="placeholder">
      <div className="placeholder__icon">{Icon ? <Icon size={28} /> : null}</div>
      <h1 className="placeholder__title">{title}</h1>
      {pageType ? <span className="placeholder__type">{pageType}</span> : null}
      <p className="placeholder__text">
        This screen isn’t built in the demo. Navigation, breadcrumbs and the module
        switcher are all driven by <code>module-config</code>.
      </p>
      <p className="placeholder__hint">
        Register a component under this route’s screen key to replace this placeholder.
      </p>
    </div>
  );
};
